import { render } from "./voucher.vue?vue&type=template&id=60cd7c2f&scoped=true"
import script from "./voucher.vue?vue&type=script&lang=js"
export * from "./voucher.vue?vue&type=script&lang=js"

import "./voucher.vue?vue&type=style&index=0&id=60cd7c2f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60cd7c2f"]])

export default __exports__